import React from "react";
import * as routes from "../../../app/routes";
import { DocumentDetails } from "../../../components";
import { useParams } from "react-router-dom";
import * as modules from "../../../utils/modules";

function SalesDetails() {
  const parameters = useParams<{ id: string }>();
  const id = parameters.id || "";

  return (
    <DocumentDetails
      module={modules.MODULE_PURCHASES}
      operationCode={id}
      headerRoute={routes.ROUTE_PURCHASES.path}
    />
  );
}

export default SalesDetails;
